/* ICKE storefront search improvements for Shopify / Expanse.
 * Load with defer from layout/theme.liquid after theme.js.
 */
(() => {
  'use strict';

  const SEARCH_PATH = '/search';
  const DISPLAY_QUERY_PARAM = 'display_q';
  const UNIT_PATTERN = /\b(\d+)\s+(burners?|holes?|doors?|decks?|baskets?|zones?)\b/gi;
  const EXPLICIT_SYNTAX = /\b(?:AND|OR|NOT)\b|["'():]/i;
  const SPACED_MODEL_PATTERN = /^[a-z]{1,6}\s+[a-z0-9-]*\d[a-z0-9-]*$/i;

  const normalizeQuery = (value) =>
    value
      .normalize('NFKC')
      .replace(/[‐‑‒–—﹘﹣－]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();

  const buildStrictQuery = (rawValue) => {
    const query = normalizeQuery(rawValue);

    if (
      !query.includes(' ') ||
      SPACED_MODEL_PATTERN.test(query) ||
      EXPLICIT_SYNTAX.test(query)
    ) return query;

    const grouped = query.replace(UNIT_PATTERN, (_match, count, unit) =>
      `"${count} ${unit.toLowerCase()}"`,
    );
    const terms = grouped.match(/"[^"]+"|\S+/g) || [];
    if (terms.length > 1) return terms.join(' AND ');
    return grouped !== query && terms.length === 1 ? terms[0] : query;
  };

  const setHiddenInput = (form, name, value) => {
    let input = form.querySelector(`input[type="hidden"][name="${name}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  };

  const isSearchForm = (form) => {
    try {
      return new URL(form.action, window.location.href).pathname === SEARCH_PATH;
    } catch (_error) {
      return false;
    }
  };

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('form');
      if (!form || !isSearchForm(form)) return;

      const queryInput = form.querySelector('input[name="q"]');
      if (!queryInput) return;

      const originalQuery = normalizeQuery(queryInput.value);
      const strictQuery = buildStrictQuery(originalQuery);

      queryInput.value = strictQuery;
      setHiddenInput(form, 'type', 'product');

      if (strictQuery !== originalQuery) {
        setHiddenInput(form, DISPLAY_QUERY_PARAM, originalQuery);
      }
    },
    true,
  );

  const restoreCustomerQuery = () => {
    if (window.location.pathname !== SEARCH_PATH) return;

    const params = new URLSearchParams(window.location.search);
    const originalQuery = params.get(DISPLAY_QUERY_PARAM);
    const strictQuery = params.get('q');
    if (!originalQuery || !strictQuery) return;

    document.querySelectorAll('form[action$="/search"] input[name="q"]').forEach((input) => {
      input.value = originalQuery;
    });

    if (document.title.includes(strictQuery)) {
      document.title = document.title.replace(strictQuery, originalQuery);
    }

    document
      .querySelectorAll('.pagination a[href], a[href*="/search?page="]')
      .forEach((link) => {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set(DISPLAY_QUERY_PARAM, originalQuery);
        link.href = `${url.pathname}${url.search}`;
      });
  };

  const cleanSortControl = () => {
    document.querySelectorAll('select#SortBy, select[name="SortBy"]').forEach((select) => {
      Array.from(select.options)
        .filter((option) => option.textContent.trim().toLowerCase() === 'sort')
        .forEach((option) => option.remove());

      const label = document.querySelector(`label[for="${select.id}"]`);
      if (label) {
        label.textContent = 'Sort by';
        label.classList.remove('visually-hidden');
        label.classList.add('icke-sort-label');
      }

      const requestedSort = new URLSearchParams(window.location.search).get('sort_by');
      if (!requestedSort || requestedSort === 'title-ascending') {
        select.value = 'relevance';
      }
    });
  };

  const initialize = () => {
    restoreCustomerQuery();
    cleanSortControl();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
